const Align = [
	{
		'id': 'left', 
		'type': 'icon',
		'icon': 'align-left'
	},
	{
		'id': 'center', 
		'type': 'icon',
		'icon': 'align-center'
	},
	{
		'id': 'right', 
		'type': 'icon',
		'icon': 'align-right'
	},
	{
		'id': 'justify', 
		'type': 'icon',
		'icon': 'align-justify'
	}
]

export default Align


// WEBPACK FOOTER //
// ./src/data/Align.js